import Vue from "vue";
import Router from "vue-router";
import store from "../store";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页",
          },
        },
        {
          path: "/newsAndNotices/news",
          name: "news",
          component: (resolve) => require(["@/view/News"], resolve),
          meta: {
            title: "中心动态",
          },
          children: [],
        },
        {
          path: "/newsAndNotices/notices",
          name: "notices",
          component: (resolve) => require(["@/view/Notices"], resolve),
          meta: {
            title: "中心动态",
          },
          children: [],
        },
        {
          path: "/newsAndNotices/nanDetail",
          name: "nanDetail",
          component: (resolve) => require(["@/view/NaNDetail"], resolve),
          meta: {
            title: "中心动态详情",
          },
          children: [],
        },
        {
          path: "/service",
          name: "service",
          component: (resolve) => require(["@/view/Service"], resolve),
          meta: {
            title: "业务介绍",
          },
          // children: [
          //   {
          //     path: '/service/examDetails',
          //     name: 'examDetails',
          //     component: resolve => require(['@/view/examDetails'], resolve),
          //   }
          // ]
        },
        {
          path: "/serviceHall",
          name: "serviceHall",
          component: (resolve) => require(["@/view/ServiceHall"], resolve),
          meta: {
            title: "服务大厅",
          },
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: (resolve) => require(["@/view/AboutUs"], resolve),
          meta: {
            title: "关于我们",
          },
        },
        {
          path: "/examDetails",
          name: "examDetails",
          component: (resolve) => require(["@/view/examDetails"], resolve),
          meta: {
            title: "事业单位公开招聘考试",
          },
        },
        {
          path: "/recruitmentDetails",
          name: "recruitmentDetails",
          component: (resolve) =>
            require(["@/view/recruitmentDetails"], resolve),
          meta: {
            title: "事业单位公开招考详情",
          },
        },
        {
          path: "/dailyRecruitDetails",
          name: "dailyRecruitDetails",
          component: (resolve) =>
            require(["@/view/dailyRecruitDetails"], resolve),
          meta: {
            title: '日常招聘详情'
          }
        },
        {
          path: '/jobDetails',
          name: 'jobDetails',
          component: resolve => require(['@/view/JobDetails'], resolve),
          meta: {
            title: '岗位详情'
          }
        },
        {
          path: '/recruitmentExamDetails',
          name: 'recruitmentExamDetails',
          component: resolve => require(['@/view/recruitmentExamDetails'], resolve),
          meta: {
            title: '报考岗位详情'
          }
        }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  // 判断是否需要显示头部
  if (
    to.path === "/examDetails" ||
    to.path === "/recruitmentDetails" ||
    to.path === "/dailyRecruitDetails" ||
    to.path === '/jobDetails' ||
    to.path === '/recruitmentExamDetails'
  ) {
    store.commit("updateisShowHeader", false);
  } else {
    store.commit("updateisShowHeader", true);
  }
  // 判断是否需要返回按钮
  if(to.path === '/home'){
    store.commit('setIsShowGoBack', false)
  }else{
    store.commit('setIsShowGoBack', true)
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js